module.exports = __webpack_public_path__ + "img/spot-blue-9.png";